export default __webpack_public_path__ + "static/media/free_spin_member.7b215201.csv";